import { render, staticRenderFns } from "./ProjectCardFull.vue?vue&type=template&id=79803606&scoped=true"
import script from "./ProjectCardFull.vue?vue&type=script&lang=js"
export * from "./ProjectCardFull.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardFull.vue?vue&type=style&index=0&id=79803606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79803606",
  null
  
)

export default component.exports